<template>
  <div class="favorited">
    <div class="filter-wrapper">
      <div class="first-block">
        <SearchInput />
        <CustomDropdown
          :noneValueDisplay="'Types'"
          :valueList="[1, 2, 3, 4]"
          :displayList="['Artworks', 'Artworks', 'Artworks', 'Artworks']"
        />
        <CustomDropdown
          :noneValueDisplay="'Amount'"
          :valueList="[1, 2, 3, 4]"
          :displayList="['Bundles', 'Bundles', 'Bundles', 'Bundles']"
        />
      </div>
    </div>
    <div class="artwork-wrapper">
      <NftCard />
      <NftCard />
      <NftCard />
      <NftCard />
    </div>
  </div>
</template>

<script>
import SearchInput from '@/components/BaseComponents/SearchInput.vue';
import CustomDropdown from '@/components/BaseComponents/CustomDropdown.vue';
import NftCard from '@/components/BaseComponents/NftCard.vue';

export default {
  components: { SearchInput, CustomDropdown, NftCard }
};
</script>

<style lang="scss" scoped>
.favorited {
  .filter-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .first-block {
      display: flex;
      flex-wrap: wrap;
      div {
        margin-right: 10px;
      }
    }
  }
  .artwork-wrapper {
    margin-top: 20px;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
  }
}
</style>
